<mat-toolbar>
  Ajustes
</mat-toolbar>

<div class="pageContent">
  <mat-card class='mat-card pointer' routerLink="/usersaccounts">
    <mat-card-header>
      <div mat-card-avatar>
        <mat-icon color="primary" class='cardIcon'>people_outline</mat-icon>
      </div>
      <mat-card-title class='cardTitle'>Usuarios</mat-card-title>
    </mat-card-header>
    <p class='cardText'>Gestionar los usuarios del sistema.</p>
  </mat-card>
  <mat-card class='mat-card pointer' routerLink="/balanzas">
    <mat-card-header>
      <div mat-card-avatar>
        <mat-icon color="primary" class='cardIcon'>scale</mat-icon>
      </div>
      <mat-card-title class='cardTitle'>Puntos de conexión</mat-card-title>
    </mat-card-header>
    <p class='cardText'>Gestionar los puntos de conexión del sistema.</p>
  </mat-card>
  @if (authService.canAccessSocketDiagnostico()) {
    <mat-card class='mat-card pointer' routerLink="/socket-diagnostico">
      <mat-card-header>
        <div mat-card-avatar>
          <mat-icon color="primary" class='cardIcon'>settings_ethernet</mat-icon>
        </div>
        <mat-card-title class='cardTitle'>Servidor Socket</mat-card-title>
      </mat-card-header>
      <p class='cardText'>Comprobar que el servidor socket responde correctamente.</p>
    </mat-card>
  }
</div>
